import { render } from "./AboutUs.vue?vue&type=template&id=892eca6c&scoped=true"
import script from "./AboutUs.vue?vue&type=script&lang=js"
export * from "./AboutUs.vue?vue&type=script&lang=js"

import "./AboutUs.vue?vue&type=style&index=0&id=892eca6c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-892eca6c"]])

export default __exports__